import { filterToFormControl } from '@shared/modules/list/helpers/filter-name.helper';
import { ListEvent, ListEventType } from '@shared/modules/list/model/list-event.model';
import { BaseComponent } from '../base.component';
import { ListParams, ListService } from '@shared/modules/list/services/list.service';
import { TaskStatus } from '@shared/enums/task-status.enum';

export class BaseListFiltersComponentComponent extends BaseComponent {
  constructor(public service: ListService) {
    super();
    this.listenQueryParams();
  }

  handleSelectedValues(items: any[], controlName: string) {
    this.service.setTempChips({
      ...this.service.tempChips,
      [controlName]: items
    });
  }

  refreshChips() {
    const params = this.service.getParams();
    const chips = { ...this.service.tempChips };

    Object.keys(chips).forEach((key) => {
      if (
        !Object.keys(params)
          .map((k) => filterToFormControl(k.replace('filters', '')))
          .includes(key)
      ) {
        delete chips[key];
      }
    });

    this.service.setTempChips(chips);
  }

  listenQueryParams() {
    this.sub = this.service.eventEmitter.subscribe(({ type, data }: ListEvent<any>) => {
      if (type === ListEventType.QUERY_PARAMS) this.setFiltersToForm(data);
    });
  }

  setFiltersToForm(params: ListParams) {
    Object.keys(params).forEach((key: string) => {
      const k = filterToFormControl(key.replace('filters', ''));
      if (!k || !this.service.filtersForm.get(k)) {
        return;
      }

      const rawValue = params[key];
      const isInOperator = key.includes('[in]');

      if (Array.isArray(rawValue)) {
        this.service.filtersForm.get(k).setValue(rawValue.map((v) => this.castValue(v)));
        return;
      }

      if (typeof rawValue === 'string' && rawValue.includes(',')) {
        this.service.filtersForm.get(k).setValue(rawValue.split(',').map((v) => this.castValue(v.trim())));
        return;
      }

      if (isInOperator) {
        this.service.filtersForm.get(k).setValue([this.castValue(rawValue)]);
        return;
      }

      this.service.filtersForm.get(k).setValue(this.castValue(rawValue));
    });
  }

  private castValue(value: any) {
    return isNaN(Number(value)) ? value : Number(value);
  }

  shouldShowClearFilters() {
    let show = false;
    Object.keys(this.service.filtersForm.value).forEach((key) => {
      if (this.service?.filtersForm?.value[key]) {
        show = true;
      }
    });
    return show;
  }

  clearFilters() {
    Object.keys(this.service?.filtersForm.value).forEach((key) => {
      this.service.filtersForm.get(key).setValue(null);
    });
  }

  onChangeFilter() {
    Object.keys(this.service.filtersForm.value).forEach((key: string) => {
      let value = this.service.filtersForm.value[key];
      Array.isArray(value) && !value.length ? (value = null) : null;
      if (key === '[deleted]') {
        value = value ? 1 : 0;
      }
      if (key === '[show_completed]') {
        const statusesFiltrValue = this.service.filtersForm.get('[a-status][in][]').value || [];
        value = statusesFiltrValue.indexOf(TaskStatus.COMPLETED) !== -1 ? 1 : 0;
      }
      if (key === '[show_cancelled]') {
        const statusesFiltrValue = this.service.filtersForm.get('[a-status][in][]').value || [];
        value = statusesFiltrValue.indexOf(TaskStatus.CANCELLED) !== -1 ? 1 : 0;
      }
      this.service.setFilter(key, value);
    });
  }
}
